import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { ImageUrl } from "../config/helpers";

const SystemMessageModal = ({
  systemMessageModal = false,
  setSystemMessageModal,
  message,
  path,
}) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(path);
    setSystemMessageModal(false);
  };
  return (
    <div>
      <Modal
        centered
        open={systemMessageModal}
        footer={null}
        onCancel={() => setSystemMessageModal(false)}
      >
        <div className="flex flex-col justify-center items-center bg-white py-4">
          <img src={ImageUrl("check.png")} alt="check" />
          <h3 className="font-tavi text-3xl text-customBlack max-desktop:text-xl max-sm:text-lg text-center mt-4 font-semibold">
            System Message
          </h3>
          <h5 className=" my-3 text-center font-euclid text-sm max-sm:text-xs font-normal text-[#333333]">
            {message}
          </h5>
          <div className="flex flex-col items-center justify-center w-32 2xl:w-52">
            <button
              className="uppercase bg-button py-4 text-black rounded-lg text-sm font-bold max-sm:text-xs max-md:px-4 my-4 w-full"
              onClick={handleClick}
            >
              Okay!
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SystemMessageModal;
